import { STANDARD_STAGES, type FlowKind, type StandardsRow } from './types';

// Horas del diálogo de ajuste de estándares (so=420, spec §4.2; so=340 §5). El usuario
// escribe horas con coma (o punto) decimal; el backend recibe minutos enteros de 1 a
// 60000 (1000 h), o null para "sin estándar desde ahora".

const MAX_HOURS = 1000;
const HOURS = /^\d{1,4}(?:[.,]\d{1,2})?$/;

export const FLOW_KIND_LABELS: Readonly<Record<FlowKind, string>> = {
  creacion: 'creación',
  modificacion: 'modificación',
};

/** "Procedimiento, creación". */
export function workLabel(documentTypeName: string, flowKind: FlowKind): string {
  return `${documentTypeName}, ${FLOW_KIND_LABELS[flowKind]}`;
}

/** Minutos a horas para editar: hasta dos decimales, sin ceros de más, con coma. */
export function hoursText(minutes: number | null): string {
  if (minutes === null) {
    return '';
  }
  return String(Math.round((minutes / 60) * 100) / 100).replace('.', ',');
}

export type ParsedHours = { ok: true; minutes: number | null } | { ok: false };

export function parseHours(text: string): ParsedHours {
  const t = text.trim();
  if (t === '') {
    return { ok: true, minutes: null };
  }
  if (!HOURS.test(t)) {
    return { ok: false };
  }
  const hours = Number(t.replace(',', '.'));
  // El backend admite de 1 a 60000 minutos: el valor redondeado a minutos debe caer ahí.
  const minutes = Math.round(hours * 60);
  if (minutes < 1 || hours > MAX_HOURS) {
    return { ok: false };
  }
  return { ok: true, minutes };
}

/** "Definir" si el tipo de trabajo no tiene ningún estándar vigente; si no, "Ajustar". */
export function standardVerb(row: StandardsRow): 'Definir' | 'Ajustar' {
  const any = STANDARD_STAGES.some((s) => (row.stages[s]?.standardMinutes ?? null) !== null);
  return any ? 'Ajustar' : 'Definir';
}
